import { FeesRepo } from '@services/fees.repo';
import * as moment from 'moment';
import * as _ from 'lodash';

class SharedSearchController {
  // Shared state - bound from parent
  public fromDate: Date;
  public toDate: Date;
  public displayMCB: boolean;
  public threshold: number;
  public currentDate: Date;
  public lastTwelveMonths: Date;

  // Callbacks to parent
  public onSearch: () => void;
  public onAll: () => void;

  /** @ngInject */
  constructor(
    private feesRepo: FeesRepo,
    private notifyjs
  ) {
    var date = new Date();
    this.currentDate = date;
    this.lastTwelveMonths = new Date(
      moment(date).subtract(12, 'months').startOf('month').format('YYYY-MM-DD')
    );
  }

  formatDate(selectedDate: Date) {
    return moment(selectedDate).endOf('month').format('YYYY-MM');
  }

  handleSearch = () => {
    if (this.onSearch) {
      this.onSearch();
    }
  };

  handleAll = () => {
    if (this.onAll) {
      this.onAll();
    }
  };
}

export const sharedSearch: angular.IComponentOptions = {
  template: require('./fees.instructions.shared-search.html'),
  controller: SharedSearchController,
  bindings: {
    fromDate: '=',
    toDate: '=',
    displayMCB: '=',
    threshold: '=',
    currentDate: '<',
    lastTwelveMonths: '<',
    onSearch: '&',
    onAll: '&',
  },
};




// WEBPACK FOOTER //
// ./src/app/fees/instructions/shared-search/fees.instructions.shared-search.ts